module.exports = __webpack_public_path__ + "img/04-3-5挖掘数据.3d08f294.svg";